import LogService from "services/LogService";
import CREDIT_EVENTS from "./CreditEvents";
import InvoiceService from "services/InvoiceService";
import { modalStateValues, modalType } from "services/constants";

export const getInvoiceEmail = async ({
  orderId,
  invoiceEmail,
  toast,
  setLoadingInvoiceId,
  setModalData
}) => {
  if (!orderId || !invoiceEmail) {
    toast({
      title: "Error",
      description: "Something went wrong. Please try again.",
      variant: "destructive"
    });
  }
  try {
    setLoadingInvoiceId(orderId);

    await InvoiceService.emailInvoice({
      orderId: orderId.toString(),
      email: invoiceEmail
    });

    setModalData({
      state: modalStateValues.open,
      type: modalType.INVOICE_EMAIL_MODAL,
      data: {
        orderId,
        invoiceEmail
      }
    });
    LogService.log(CREDIT_EVENTS.GET_EMAIL_INVOICE_CLICKED, {
      orderId,
      invoiceEmail
    });
  } catch (error) {
    console.error("Error generating invoice:", error);
    toast({
      title: "Error",
      description:
        error?.message || "Failed to generate invoice. Please try again.",
      variant: "destructive"
    });
  } finally {
    setLoadingInvoiceId(null);
  }
};
